module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "min-h-dvh flex flex-col"
  }, [_c('app-header', {
    staticClass: "bg-gradient-to-b from-secondary to-primary pb-8"
  }), _vm._v(" "), _c('nav', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-[1.5rem] relative z-20 isolate shadow-xl -mt-6 py-8 px-2 flex-1 overflow-y-auto pb-28"
  }, [(_vm.actions.length > 0) ? _c('a', {
    staticClass: "relative mx-4 mb-4 p-3 bg-orange text-white rounded-xl flex items-center justify-between shadow-lg uppercase",
    attrs: {
      "id": "btn-offline"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.trySync('synchro')
      }
    }
  }, [(_vm.actions.length > 0) ? _c('i', {
    staticClass: "actions absolute -top-2 -right-2 z-10 shadow-md bg-alert text-white font-bold text-sm flex items-center justify-center h-6 w-6 rounded-full"
  }, [_vm._v("\n                    " + _vm._s(_vm.actions.length) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Actions")]), _c('br'), _vm._v("\n                    Non synchronisées\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-reload bg-white opacity-50"
  })]) : _vm._e(), _vm._v(" "), (_vm.actions.length <= 0) ? _c('a', {
    staticClass: "mx-4 mb-4 p-3 bg-orange text-white rounded-xl flex items-center justify-between shadow-lg uppercase",
    attrs: {
      "id": "btn-sync"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.trySync('init')
      }
    }
  }, [_c('span', {
    staticClass: "text-2xl"
  }, [_c('strong', [_vm._v("Synchroniser")]), _vm._v("\n                    Les données\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-reload bg-white opacity-50"
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'technicien') ? _c('span', {
    staticClass: "if"
  }, [_c('router-link', {
    staticClass: "relative mx-4 mb-4 p-3 bg-secondary text-white rounded-xl flex items-center justify-between shadow-lg",
    attrs: {
      "id": "btn-interventions",
      "to": "liste-fibsdd"
    }
  }, [(this.numberFibsdd() > 0) ? _c('i', {
    staticClass: "actions absolute -top-2 -right-2 z-10 shadow-md"
  }, [_vm._v("\n                        " + _vm._s(this.numberFibsdd()) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text-2xl font-semibold"
  }, [_vm._v("Intervention" + _vm._s(this.numberFibsdd() > 1 ? 's' : ''))]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-gear bg-white opacity-25"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mx-4 grid grid-cols-2 gap-4 mb-6"
  }, [_c('router-link', {
    staticClass: "relative bg-white rounded-lg shadow w-full h-24",
    attrs: {
      "id": "btn-contrat",
      "to": "contrat-assemblage"
    }
  }, [_c('i', {
    staticClass: "absolute top-2 right-2 h-8 w-8 mask mask-file bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute bottom-5 left-2 text-primary text-lg sm:text-xl"
  }, [_vm._v("\n                            Contrat"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("d'assemblage")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "relative bg-white rounded-lg shadow w-full h-24",
    attrs: {
      "id": "btn-interventions-d",
      "to": "ctrl-multi"
    }
  }, [_c('i', {
    staticClass: "absolute top-2 right-2 h-8 w-8 mask mask-pipe-valve bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute left-3 top-1/2 -translate-y-1/2 text-primary text-sm sm:text-base md:text-lg leading-tight"
  }, [_c('strong', [_vm._v("\n                                Contrôles\n                                "), _c('br', {
    staticClass: "block md:hidden"
  }), _vm._v("\n                                d’étanchéité\n                            ")]), _vm._v(" "), _c('br'), _vm._v("\n                            périodiques - multiples\n                        ")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "relative mx-4 mb-4 p-3 bg-primary text-white rounded-xl flex items-center justify-between shadow-lg",
    attrs: {
      "id": "btn-detenteurs",
      "to": "liste-detenteurs"
    }
  }, [_c('span', {
    staticClass: "text-2xl"
  }, [_c('strong', [_vm._v("Détenteurs")]), _vm._v("\n                    & installations\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-factory bg-white opacity-50"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mx-4 grid grid-cols-2 gap-4 mb-4"
  }, [_c('router-link', {
    staticClass: "relative bg-white rounded-lg shadow w-full h-20",
    attrs: {
      "id": "btn-bouteilles",
      "to": "liste-bouteilles"
    }
  }, [_c('i', {
    staticClass: "absolute top-2 right-2 h-8 w-8 mask mask-bouteille bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute bottom-2 left-2 text-primary text-xl sm:text-2xl"
  }, [_vm._v("\n                        Bouteilles\n                    ")])]), _vm._v(" "), (_vm.type === 'technicien') ? _c('router-link', {
    staticClass: "relative bg-white rounded-lg shadow w-full h-20",
    attrs: {
      "id": "btn-outils",
      "to": "liste-outils"
    }
  }, [_c('i', {
    staticClass: "absolute top-2 right-2 h-8 w-8 mask mask-tools bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute bottom-2 left-2 text-primary text-xl sm:text-2xl"
  }, [_vm._v("\n                        Outillage\n                    ")])]) : _vm._e()], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.token),
      expression: "token"
    }],
    staticClass: "mx-4 mb-30 p-4 bg-gris text-white rounded-lg flex items-center justify-between",
    attrs: {
      "target": "_blank",
      "href": ("https://admin.fi360.fr/tutorials?token=" + _vm.token)
    }
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Tutoriels")])]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-info bg-white opacity-30"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271a3504","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Home.vue
// module id = 1018
// module chunks = 0